import { IconButton, styled, Typography } from '@ethings/ui-toolkit';
import { Toolbar } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useResponsiveText } from '../../hooks';
import { innerText } from '../../util';
import { Icon } from '../icons';

interface Props {
  onCloseClicked?: () => unknown;
}

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

export const FilterToolbar: FC<Props> = ({ onCloseClicked }) => {
  const { t } = useTranslation(['common']);

  const headingText = t('common:component.filter.heading');
  const headingLength = innerText(headingText).length;
  const h6Styles = useResponsiveText('1.25rem', headingLength, {
    minFontSize: '1rem',
    maxFontSize: '1.25rem',
    textLengthThreshold: 20,
  });

  return (
    <Toolbar>
      <StyledIconButton
        aria-label="close"
        color="inherit"
        edge="start"
        onClick={onCloseClicked}
        size="large"
        data-testid="back-filter-bar-button"
      >
        <Icon icon="ArrowLeft" />
      </StyledIconButton>
      <Typography
        component="div"
        flexGrow={1}
        variant="h6"
        style={{
          fontSize: h6Styles.fontSize,
          lineHeight: h6Styles.lineHeight,
          wordBreak: h6Styles.wordBreak,
          whiteSpace: h6Styles.whiteSpace,
          overflow: h6Styles.overflow,
          textOverflow: h6Styles.textOverflow,
        }}
      >
        {headingText}
      </Typography>
    </Toolbar>
  );
};
